import React, { Component } from 'react';
import logo from './logo.svg';
import testImg from './img/ingreso.png';
import './App.css';
import TextField from '@material-ui/core/TextField';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import './pricing.css';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// import SkipPreviousIcon from '@material-ui/icons/SkipPrevious';
// import PlayArrowIcon from '@material-ui/icons/PlayArrow';
// import SkipNextIcon from '@material-ui/icons/SkipNext';


const styles = theme => ({
  root: {
    width: '100%',
    marginTop: '10px'
  },
  heading: {
    // fontSize: theme.typography.pxToRem(15),
    // fontWeight: theme.typography.fontWeightRegular,
  },
});

class Faq extends Component {

  constructor(props) {
    super(props);
    this.state = {
      users: 0,
      selected_apps: []
    }


  }








  render() {
    const { classes, theme } = this.props;
    return (
      <div className={classes.root} style={{ marginBottom: "20px", marginTop: "80px" }}>

        <div className="pricing-title">Preguntas Frecuentes</div>
        <div style={{ color: "rgba(0, 0, 0, 0.54)", marginBottom: "15px" }}>Si tienes alguna duda que no se encuentre en estas preguntas,  <strong> Contactanos</strong> </div>
        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            {/* <Typography className={classes.heading}>Expansion Panel 1</Typography> */}
            <div className="card-title">¿Que incluye la suspcripción ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
            La suscripción incluye el uso ilimitado de todos los servicios contratados, contando con servidores que garantizarán altos niveles de disponibilidad y seguridad, incluyendo a su vez un sistema de respaldo de información automático. 

            De igual manera, dentro de su suscripción se encuentran incluidos:
            <ul>
              <li>Administración y mantenimiento de servidores, eliminando la necesidad de contar con un administrador interno</li>
              <li> Actualizaciones del software, garantizando que se beneficiará de la versión mas reciente, estable y libre de errores</li>
            </ul>
      
.</div>
          </ExpansionPanelDetails>
        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">¿Como calculo mi número de usuarios ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
              Por usuario, entendemos a cualquier recurso dentro de su organización que tendrá acceso a las aplicaciones en modo lectura/escritura. Es importante destacar que no se contabilizan como usuarios adicionales a los clientes que se conectan a los “Servicios En línea al cliente”(por ejemplo, no se considera un usuario al cliente de su laboratorio que consulta sus resultados).
      
      
.</div>
          </ExpansionPanelDetails>
        </ExpansionPanel>


        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">¿Como elijo un plan de soporte ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
              Los planes de asistencia se encuentran diseñados para brindar a su organización el respaldo necesario para lograr obtener el mayor beneficio de las aplicaciones implementadas. En la mayoría de los casos, el costo en el plan de asistencia es decreciente en el tiempo, ya que la necesidad de asistencia disminuye sustancialmente. En otras palabras, es recomendable contratar planes de soporte con mayor cantidad de servicios al inicio, siendo posible pasar a planes mas básicos cuando sus necesidades disminuyan.
      
      
.</div>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">Al seleccionar algunas aplicaciones, otras son seleccionadas automáticamente ¿ Por Que ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
              Esto se debe a que algunas aplicaciones se basan parcialmente en las funciones provistas por
      otras, es decir, poseen una dependencia. Por ejemplo, no es posible emitir informes de resultados
      sin cargar previamente dichos resultados.
      
.</div>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">No deseo contratar un take-off pack ¿puedo comenzar a utilizar mis aplicaciones de todas formas ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
            Por supuesto !.<br></br>
             	Nuestros planes “Take Off” constan de servicios adicionales para la implementación inicial de la suite. La elección del plan correcto le permitirá optimizar la implementación / parametrización inicial,  logrando un incremento en la velocidad de adopción y productividad. 
		Al tratarse de servicios específicos, estos planes suelen ser contratados una vez al comenzar con el uso de la solución y no tienen ningún cargo recurrente.
		No obstante esto, es totalmente posible adoptar cualquier de las aplicaciones de Kalenis sin la necesidad de un plan de Take Off. 
		El acceso a Kalenis Learning Center incluido en la suscripción, le garantiza la documentación necesaria para comprender y utilizar cualquiera de las aplicaciones, así como demostraciones en video.
      
.</div>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">En caso de que se me acaben las consultas funcionales de mi plan de soporte, ¿que sucede si la aplicación tiene un error ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
            Las consultas funcionales están destinadas a asesorar en el correcto uso de la solución y colaborar
en la resolución de los casos que lo requieran. En caso de surgir un error de la aplicación, el
mismo será corregido a nuestro exclusivo cargo y no se descontará de las  consultas funcionales
contratadas.
      
.</div>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">¿El precio de las aplicaciones debe multiplicarse por la cantidad de usuarios ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
            No ! El precio de las aplicaciones es compartido por todos los usuarios. Por ejemplo, si usted contrata la aplicación de ingreso de muestras en base anual, pagará USD 20 por mes, sin importar la cantidad de usuarios que posea.
.</div>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">Si deseo migrar a una versión On Premise para utilizar mi infraestructura, ¿es posible ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
            Por supuesto ! <br></br>
            Contamos con un servicio que le permitirá realizar la migración a su infraestructura de forma ágil y segura. Consultenos si desea conocer mas detalles al respecto.

.</div>
          </ExpansionPanelDetails>

        </ExpansionPanel>

        <ExpansionPanel>
          <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
            <div className="card-title">¿Que sucede si decido dar de baja el servicio ?</div>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <div className="faq-content">
            El servicio puede ser dado de baja en cualquier momento, brindando aviso vía correo electrónico con un mes de anticipación y encontrándose su cuenta al día.<br></br>
            <strong>Podrá descargar sin limitaciones o costo alguno su base de datos, obteniendo toda la información que ha generado dentro de la solución.</strong>

</div>
          </ExpansionPanelDetails>

        </ExpansionPanel>



      </div>
    );
  }
}


Faq.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Faq);
// export default AppsGrid;